const isDevelopment = process.env.NODE_ENV === 'development';

export const ENDPOINT = isDevelopment ? 'http://localhost:3031' : 'https://server-eu-1.petapps.org/eaa0f8bf-e4e1-4228-91ac-019af2cdb73b';
export const WEBSOCKET = isDevelopment ? 'http://localhost:3422' : 'https://server-eu-1.petapps.org';
export const WEBSOCKET_URL = isDevelopment ? undefined : '/7cf1620a-9c4e-4727-ac81-8d06279547cd/socket.io/';

const Urls = { ENDPOINT, WEBSOCKET, WEBSOCKET_URL };

export default Urls;
